/*
  Affordable Turf ordering rules.
  Keeps turf roll add-to-cart open, but blocks checkout until the cart reaches
  the required total square footage across all full-roll turf products.
*/
(function () {
  if (window.ATUOrderingRulesLoaded) {
    return;
  }

  window.ATUOrderingRulesLoaded = true;

  var TurfCore = window.ATUTurfOrdering;
  if (!TurfCore) return;

  var ROLL_WIDTH_FT = TurfCore.DEFAULTS.ROLL_WIDTH_FT;
  var CART_MIN_SQFT = TurfCore.DEFAULTS.MIN_CHECKOUT_SQFT;
  var MAX_ROLL_LENGTH_FT = TurfCore.DEFAULTS.MAX_ROLL_LENGTH_FT;
  var cartState = {
    blocked: false,
    violations: []
  };
  var cartRefreshTimer = null;

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function parseRollSize(value) {
    return TurfCore.parseRollDimensions(value, {
      rollWidthFt: ROLL_WIDTH_FT,
      maxRollLengthFt: MAX_ROLL_LENGTH_FT
    });
  }

  function collectRollSummary(items) {
    return TurfCore.collectCartTurfSummary(items, {
      rollWidthFt: ROLL_WIDTH_FT,
      maxRollLengthFt: MAX_ROLL_LENGTH_FT
    });
  }

  function checkCart(cart) {
    var summary = collectRollSummary(cart && cart.items);

    if (summary.area <= 0 || summary.area >= CART_MIN_SQFT) {
      return [];
    }

    return [{
      area: summary.area,
      min: CART_MIN_SQFT,
      remaining: CART_MIN_SQFT - summary.area,
      remainingLength: Math.ceil((CART_MIN_SQFT - summary.area) / ROLL_WIDTH_FT),
      products: summary.products,
      sizes: summary.sizes
    }];
  }

  function addStyle() {
    if (document.getElementById('atu-ordering-style')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'atu-ordering-style';
    style.textContent = [
      '.atu-roll-minimum-note,.atu-cart-minimum-note{width:100%;box-sizing:border-box;margin:12px 0;padding:12px 14px;border:1px solid rgba(145,94,24,.32);border-radius:6px;background:#fff8e8;color:#4b3514;font-size:14px;line-height:1.45;}',
      '.atu-roll-minimum-note[hidden],.atu-cart-minimum-note[hidden]{display:none!important;}',
      '.atu-roll-minimum-note strong,.atu-cart-minimum-note strong{display:block;margin:0 0 4px;font-size:14px;color:#2f2415;}',
      '.atu-cart-minimum-note ul{margin:8px 0 0;padding-left:18px;}',
      '.atu-cart-minimum-note li+li{margin-top:5px;}',
      '.atu-cart-minimum-link{display:inline-block;margin:6px 10px 0 0;color:#1f5134;font-weight:700;text-decoration:underline;text-underline-offset:2px;}',
      '.atu-checkout-blocked{opacity:.55!important;cursor:not-allowed!important;pointer-events:none!important;}',
      '.atu-payment-hidden{display:none!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function getProductSection(formOrNode) {
    if (formOrNode && formOrNode.closest) {
      var section = formOrNode.closest('[data-section-type="product"]');

      if (section) {
        return section;
      }
    }

    return document.querySelector('[data-section-type="product"]');
  }

  function productJsonFromSection(section) {
    var script = section && section.querySelector('[data-product-json]');

    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function currentVariantFromForm(form) {
    var section = getProductSection(form);
    var data = productJsonFromSection(section);
    var product = data && data.product;
    var input = form && form.querySelector('[name="id"]');
    var variantId = input && Number(input.value);

    if (!product || !Array.isArray(product.variants) || !variantId) {
      return null;
    }

    return product.variants.filter(function (variant) {
      return Number(variant.id) === variantId;
    })[0] || null;
  }

  function currentProductFromForm(form) {
    var section = getProductSection(form);
    var data = productJsonFromSection(section);

    return data && data.product ? data.product : null;
  }

  function variantText(variant) {
    if (!variant) {
      return '';
    }

    return [
      variant.title,
      variant.option1,
      variant.option2,
      variant.option3
    ].filter(Boolean).join(' ');
  }

  function selectedOptionText(form) {
    return toArray(form && form.querySelectorAll('.product-form__single-selector, select[name^="option"]')).map(function (select) {
      if (!select || select.selectedIndex < 0) {
        return '';
      }

      return select.options[select.selectedIndex].text;
    }).join(' ');
  }

  function currentRollFromForm(form) {
    var variant = currentVariantFromForm(form);
    var parsed = parseRollSize(variantText(variant));

    if (parsed) {
      return parsed;
    }

    return parseRollSize(selectedOptionText(form));
  }

  function ensureProductNote(form) {
    var container = form && form.querySelector('.product-form__payment-container');

    if (!container && form) {
      container = form;
    }

    if (!container) {
      return null;
    }

    var note = container.querySelector('.atu-roll-minimum-note');

    if (!note) {
      note = document.createElement('div');
      note.className = 'atu-roll-minimum-note';
      note.setAttribute('role', 'status');
      note.hidden = true;

      var paymentButton = container.querySelector('.shopify-payment-button');

      if (paymentButton) {
        container.insertBefore(note, paymentButton);
      } else {
        container.appendChild(note);
      }
    }

    return note;
  }

  function setPaymentButtonHidden(form, hidden) {
    var section = getProductSection(form);
    var paymentButton = section && section.querySelector('.shopify-payment-button');

    if (!paymentButton) {
      return;
    }

    paymentButton.classList.toggle('atu-payment-hidden', hidden);
    paymentButton.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  function updatePolicyAcknowledgement(form, roll) {
    var acknowledgement = form && form.querySelector('[data-policy-acknowledgement]');

    if (!acknowledgement) {
      return;
    }

    var checkbox = acknowledgement.querySelector('input[type="checkbox"]');
    var requiresAcknowledgement = Boolean(roll);

    acknowledgement.classList.toggle('product-policy-acknowledgement--hidden', !requiresAcknowledgement);

    if (checkbox) {
      checkbox.required = requiresAcknowledgement;

      if (!requiresAcknowledgement) {
        checkbox.checked = false;
      }
    }
  }

  function updateProductForm(form) {
    var roll = currentRollFromForm(form);
    var note = ensureProductNote(form);

    updatePolicyAcknowledgement(form, roll);

    if (!roll) {
      if (note) {
        note.hidden = true;
      }

      setPaymentButtonHidden(form, false);
      return;
    }

    var underMinimum = roll.area < CART_MIN_SQFT;

    if (note) {
      note.hidden = false;
      note.innerHTML = '';

      var strong = document.createElement('strong');
      var detail = document.createElement('span');

      if (underMinimum) {
        strong.textContent = 'Checkout minimum not met yet.';
        detail.textContent = 'You can add ' + roll.label + ' to cart, but checkout requires at least ' + CART_MIN_SQFT + ' sq ft total across all 15 ft turf rolls. Current selection: ' + roll.area + ' sq ft.';
      } else {
        strong.textContent = 'This roll can meet the checkout minimum by itself.';
        detail.textContent = 'Current selection: ' + roll.label + ' = ' + roll.area + ' sq ft.';
      }

      note.appendChild(strong);
      note.appendChild(detail);
    }

    setPaymentButtonHidden(form, underMinimum);
  }

  function updateAllProductForms() {
    toArray(document.querySelectorAll('form[action*="/cart/add"]')).forEach(updateProductForm);
  }

  function productFormForNode(node) {
    var directForm = node && node.closest && node.closest('form[action*="/cart/add"]');

    if (directForm) {
      return directForm;
    }

    var section = getProductSection(node);

    return (section && section.querySelector('form[action*="/cart/add"]')) || document.querySelector('form[action*="/cart/add"]');
  }

  function ensureCartNote() {
    var checkout = document.querySelector('.cart-recap__checkout, button[name="checkout"], input[name="checkout"]');
    var target = checkout && checkout.parentElement;

    if (!target) {
      target = document.querySelector('.cart-recap .card__section, .cart-recap, form[action*="/cart"], main');
    }

    if (!target) {
      return null;
    }

    var note = document.querySelector('.atu-cart-minimum-note');

    if (!note) {
      note = document.createElement('div');
      note.className = 'atu-cart-minimum-note';
      note.setAttribute('role', 'alert');
      note.hidden = true;

      if (checkout && checkout.parentElement === target) {
        target.insertBefore(note, checkout);
      } else {
        target.insertBefore(note, target.firstChild);
      }
    }

    return note;
  }

  function checkoutTargets() {
    return toArray(document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]'));
  }

  function renderCartNote(violations) {
    var note = ensureCartNote();

    if (!note) {
      return;
    }

    if (!violations.length) {
      note.hidden = true;
      note.innerHTML = '';
      return;
    }

    note.hidden = false;
    note.innerHTML = '';

    var strong = document.createElement('strong');
    var copy = document.createElement('div');
    var list = document.createElement('ul');

    strong.textContent = 'Checkout is paused until the turf roll minimum is met.';
    copy.textContent = 'You can keep these rolls in the cart, but checkout requires at least ' + CART_MIN_SQFT + ' sq ft total across all 15 ft turf rolls:';

    violations.forEach(function (violation) {
      var item = document.createElement('li');
      var sizes = violation.sizes.length ? ' Selected rolls: ' + violation.sizes.join(', ') + '.' : '';
      var detail = document.createElement('span');

      detail.textContent = 'Current turf roll total: ' + Math.round(violation.area) + ' sq ft. Add at least ' + Math.round(violation.remaining) + ' sq ft more, for example one 15 x ' + violation.remainingLength + ' roll or larger.' + sizes;
      item.appendChild(detail);

      if (violation.products.length) {
        item.appendChild(document.createElement('br'));
      }

      violation.products.forEach(function (product) {
        var link = document.createElement('a');
        link.className = 'atu-cart-minimum-link';
        link.href = product.url;
        link.textContent = 'Add another size for ' + product.title;
        item.appendChild(link);
      });

      list.appendChild(item);
    });

    note.appendChild(strong);
    note.appendChild(copy);
    note.appendChild(list);
  }

  function setCheckoutBlocked(blocked) {
    checkoutTargets().forEach(function (target) {
      target.classList.toggle('atu-checkout-blocked', blocked);
      target.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      target.dataset.atuCheckoutBlocked = blocked ? 'true' : 'false';

      if (target.tagName === 'BUTTON') {
        if (blocked) {
          if (!target.dataset.atuOriginalType) {
            target.dataset.atuOriginalType = target.getAttribute('type') || '';
          }

          target.setAttribute('type', 'button');
        } else if (target.dataset.atuOriginalType !== undefined) {
          if (target.dataset.atuOriginalType) {
            target.setAttribute('type', target.dataset.atuOriginalType);
          } else {
            target.removeAttribute('type');
          }

          delete target.dataset.atuOriginalType;
        }
      }

      if ('disabled' in target) {
        if (blocked) {
          target.disabled = true;
          target.setAttribute('disabled', 'disabled');
        } else if (target.dataset.atuDisabledByOrderingRules === 'true') {
          target.disabled = false;
          target.removeAttribute('disabled');
        }

        target.dataset.atuDisabledByOrderingRules = blocked ? 'true' : 'false';
      }
    });

    toArray(document.querySelectorAll('.additional-checkout-buttons')).forEach(function (node) {
      node.classList.toggle('atu-payment-hidden', blocked);
      node.setAttribute('aria-hidden', blocked ? 'true' : 'false');
    });
  }

  function applyCartState(violations) {
    cartState.blocked = violations.length > 0;
    cartState.violations = violations;

    renderCartNote(violations);
    setCheckoutBlocked(cartState.blocked);
  }

  function refreshCartMinimum() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart request failed');
        }

        return response.json();
      })
      .then(function (cart) {
        applyCartState(checkCart(cart));
      })
      .catch(function () {
        setCheckoutBlocked(cartState.blocked);
      });
  }

  function scheduleCartRefresh(delay) {
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(refreshCartMinimum, delay || 120);
  }

  function blockCheckoutEvent(event) {
    if (!cartState.blocked) {
      return;
    }

    var target = event.target && event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');

    if (!target) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    renderCartNote(cartState.violations);

    var note = document.querySelector('.atu-cart-minimum-note');

    if (note && note.scrollIntoView) {
      note.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }

  function blockCheckoutSubmit(event) {
    if (!cartState.blocked) {
      return;
    }

    var form = event.target;
    var isCartForm = form && form.matches && form.matches('form[action*="/cart"]');
    var submitter = event.submitter;
    var checkoutSubmitter = submitter && (submitter.name === 'checkout' || /checkout/i.test(submitter.textContent || submitter.value || ''));

    if (!isCartForm || (submitter && !checkoutSubmitter)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    renderCartNote(cartState.violations);
  }

  function enforceRequiredAcknowledgement(event) {
    var button = event.target && event.target.closest && event.target.closest('[data-action="add-to-cart"], button[name="add"]');

    if (!button) {
      return;
    }

    var form = button.closest && button.closest('form[action*="/cart/add"]');

    if (!form) {
      return;
    }

    updateProductForm(form);

    var checkbox = form.querySelector('[data-policy-acknowledgement] input[required]');

    if (checkbox && !checkbox.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (checkbox.reportValidity) {
        checkbox.reportValidity();
      }
    }
  }

  function bindEvents() {
    document.addEventListener('variant:changed', function (event) {
      var section = event.target && event.target.closest ? event.target.closest('[data-section-type="product"]') : getProductSection(event.target);
      toArray((section || document).querySelectorAll('form[action*="/cart/add"]')).forEach(updateProductForm);
    });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('.product-form__single-selector, form[action*="/cart/add"] select, form[action*="/cart"] input, form[action*="/cart"] select')) {
        var form = productFormForNode(event.target);

        if (form) {
          window.setTimeout(function () {
            updateProductForm(form);
          }, 0);
          window.setTimeout(function () {
            updateProductForm(form);
          }, 180);
        }

        scheduleCartRefresh(250);
      }
    }, true);

    document.addEventListener('click', enforceRequiredAcknowledgement, true);
    document.addEventListener('click', blockCheckoutEvent, true);
    document.addEventListener('submit', blockCheckoutSubmit, true);
    document.addEventListener('cart:refresh', function () {
      scheduleCartRefresh(250);
    });
    document.addEventListener('cart:updated', function () {
      scheduleCartRefresh(250);
    });
    document.addEventListener('product:added', function () {
      scheduleCartRefresh(450);
    });
    window.addEventListener('pageshow', function () {
      scheduleCartRefresh(120);
      ensureHomeQuickOrder();
    });
  }

  function ensureHomeQuickOrder() {
    if (window.location.pathname !== '/' && window.location.pathname !== '') {
      return;
    }

    toArray(document.querySelectorAll('.slideshow a, [id*="__slideshow"] a')).forEach(function (link) {
      if (!/Get Roll Size\s*&\s*Quote/i.test(link.textContent || '')) {
        return;
      }

      link.textContent = 'Quick Order';
      link.setAttribute('href', '/collections/all-turf-products');
      link.setAttribute('aria-label', 'Quick order all turf products');
    });

    var section = document.querySelector('.turf-buyer-path');

    if (!section) {
      return;
    }

    var actions = section.querySelector('.turf-buyer-path__actions');

    if (!actions) {
      return;
    }

    var quickOrder = actions.querySelector('a[href*="/collections/all-turf-products"]');

    if (!quickOrder) {
      quickOrder = document.createElement('a');
      actions.insertBefore(quickOrder, actions.firstElementChild);
    }

    quickOrder.className = 'turf-buyer-path__button turf-buyer-path__button--primary';
    quickOrder.href = '/collections/all-turf-products';
    quickOrder.setAttribute('aria-label', 'Quick order all turf products');
    quickOrder.textContent = 'Quick Order';

    var calculatorLink = actions.querySelector('a[href*="/pages/turf-calculator"]');

    if (calculatorLink) {
      calculatorLink.className = 'turf-buyer-path__button turf-buyer-path__button--secondary';
      calculatorLink.href = '/pages/turf-calculator?view=turf-calculator';
      calculatorLink.textContent = 'Get Roll Size & Quote';
      actions.insertBefore(calculatorLink, quickOrder.nextSibling);
    }

    actions.insertBefore(quickOrder, actions.firstElementChild);

    var steps = toArray(section.querySelectorAll('.turf-buyer-path__step'));
    var sizingStep = steps[2];
    var sizingTitle = sizingStep && sizingStep.querySelector('strong');
    var sizingCopy = sizingStep && sizingStep.querySelector('p');

    if (sizingTitle) {
      sizingTitle.textContent = 'Calculate or quick order';
    }

    if (sizingCopy) {
      sizingCopy.textContent = 'Use the calculator for uncertain projects, or Quick Order if you already know the turf and roll size.';
    }
  }

  function init() {
    addStyle();
    ensureHomeQuickOrder();
    window.setTimeout(ensureHomeQuickOrder, 500);
    updateAllProductForms();
    refreshCartMinimum();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
